module.exports = __webpack_public_path__ + "static/media/24.858824c2.png";